import { render, staticRenderFns } from "./MobileGroupList.vue?vue&type=template&id=4c94c9fb&scoped=true"
import script from "./MobileGroupList.vue?vue&type=script&lang=js"
export * from "./MobileGroupList.vue?vue&type=script&lang=js"
import style0 from "./MobileGroupList.vue?vue&type=style&index=0&id=4c94c9fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c94c9fb",
  null
  
)

export default component.exports